// Übersetzungsmechanismus für das Frontend
const keys = {
  Ansprechpartner: "Maßnahme erstellt von",
  Antragsteller: "Antragsteller*in",
  Nutzer: "Nutzer*in",
  label_Zuständig: "Zuständig (Verwaltung)",
  label_MassnahmeErsteller: "Maßnahme erstellt von",
  Rechtsgrundlage_WHF: "Rechtsgrundlage für die Befristung ist § 6 Wissenschaftszeitvertragsgesetz (WissZeitVG).",
  Rechtsgrundlage_WHK: "Rechtsgrundlage für die Befristung ist § 2 Wissenschaftszeitvertragsgesetz (WissZeitVG)",
  Rechtsgrundlage_SHK: "Rechtsgrundlage für die Befristung ist § 6 Wissenschaftszeitvertragsgesetz (WissZeitVG).",
};

export default function TR(from, args) {
  const val = keys[from];
  if (val) {
    if (typeof val === "function") {
      return val(args);
    }
    return val;
  }
}
